<template>
  <DefaultLayout>
    <template #buttons>
      <LocalUserCreateAction @created="reload" v-if="can('USER_MANAGE')" />
    </template>

    <LocalUserFilter :filters="filters">
      <h1 class="h5 mt-2">
        {{ i18n('Local Users') }}
        <span class="small text-muted" v-if="!pagination?.total">({{ localUsers.length }})</span>
        <span class="small text-muted" v-else>({{ pagination?.total }})</span>
      </h1>
      <template #buttons>
        <ExportToExcelAction cssClass="btn btn-sm btn-outline-dark ms-1" />
      </template>
    </LocalUserFilter>

    <LocalUserList :pagination="pagination" :localUsers="localUsers" :loading="loading"
      :autoLazyLoad="!!pagination.nextPageURI" @deleted="reload" @updating="loading = true" @updated="reload"
      @next="nextPage" @goToPage="goToPage" />
  </DefaultLayout>
</template>

<script>
import paginatedViewMixin from "@/mixins/common/paginatedViewMixin.js";
import api from "@/api.js";
import { canAccessPage } from "@/routeAcl.js";
import DefaultLayout from "@/layouts/DefaultLayout.vue";
import ExportToExcelAction from "@/components/common/actions/ExportToExcelAction.vue";
import LocalUserCreateAction from "@/components/localUser/LocalUserCreateAction.vue";
import LocalUserFilter from "@/components/localUser/LocalUserFilter.vue";
import LocalUserList from "@/components/localUser/LocalUserList.vue";

export default {
  mixins: [paginatedViewMixin,],
  components: {
    DefaultLayout,
    ExportToExcelAction,
    LocalUserCreateAction,
    LocalUserFilter,
    LocalUserList,
  },
  data() {
    return {
      listPropertyName: 'localUsers',
      apiResource: `localUsers`,
      localUsers: [],
    }
  },
  mounted() {
    this.$root.setPageTitle(this.i18n('Local Users'));
    api.auth().then((user) => {
      this.$root.loggedUser = user;

      if (!user.loggedIn) {
        return; // Layout non-anonymous will handler redirect
      }

      if (!canAccessPage(this.$route?.name, user, this.$root.features)) {
        this.$router.push({ name: 'Index', });
        return;
      }

      this.load();
    });
  },
  watch: {
    params: {
      handler() {
        this.pagination.loadPages = 1;
        this.reload();
      },
      deep: true,
    },
  },
  methods: {
    extendApiParams(params) {
      params.acl = 'localUser';
    },
  },
};
</script>